import { render, staticRenderFns } from "./VEmployee.vue?vue&type=template&id=067cd6ab&scoped=true&lang=pug"
import script from "./VEmployee.vue?vue&type=script&lang=ts"
export * from "./VEmployee.vue?vue&type=script&lang=ts"
import style0 from "./VEmployee.vue?vue&type=style&index=0&id=067cd6ab&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067cd6ab",
  null
  
)

export default component.exports